module.exports = __webpack_public_path__ + "img/barracks_tech_Normal_ua.222561f3.webp";